import TooltippsBadges from "../../99-libs/tooltipps-badges";
import addToCart from "../cart/add_to_cart";

("use strict");

let wrapper = document.querySelector(".products-list");
let primaryCategorySelector = null;
let secondaryCategorySelector = null;

let productSubGroups = [];
let templates = {};

let primaryGroupUid = -1;
let secondaryGroupUid = -1;
let productViewActive = true;
let layoutView = "list";

let productsCount = 0;
let partsCount = 0;

const tooltipps = new TooltippsBadges();

function initializeProductList() {
  wrapper = document.querySelector(".products-list");
  primaryCategorySelector = document.querySelector("#sub");
  secondaryCategorySelector = document.querySelector("#subsub");
  if (!wrapper || !primaryCategorySelector || !secondaryCategorySelector)
    return;

  productSubGroups = window.products;
  if (!productSubGroups) return;

  templates = {
    container: document.querySelector("#container-template"),
    product: document.querySelector("#product-template"),
    firstBadge: document.querySelector("#first-badge-template"),
    AdditionalBadge: document.querySelector("#additional-badge-template"),
  };

  const layoutRadio = document.querySelectorAll(
    "input[type=radio][name=layout]"
  );

  if (layoutRadio.length) {
    layoutRadio.forEach((radio) => {
      radio.addEventListener("change", () => {
        setCookie(
          "layout",
          document.querySelector('input[name="layout"]:checked').value,
          30
        );
        if (radio.value == "grid") {
          wrapper.classList.remove("products-list__list-layout");
          wrapper.classList.add("products-list__grid-layout");
        } else {
          wrapper.classList.remove("products-list__grid-layout");
          wrapper.classList.add("products-list__list-layout");
        }
      });
    });
  }

  const productsFilterSelectPrimary = document.querySelector(
    ".products-filter__select--primary"
  );
  if (productsFilterSelectPrimary) {
    productsFilterSelectPrimary.addEventListener("change", function () {
      secondaryGroupUid = -1;
      productsFilterSelectSecondary.value = secondaryGroupUid;
      filterList();
    });
  }
  const productsFilterSelectSecondary = document.querySelector(
    ".products-filter__select--secondary"
  );
  if (productsFilterSelectSecondary) {
    productsFilterSelectSecondary.addEventListener("change", function () {
      filterList();
    });
  }

  const productsViewChange = document.querySelectorAll(
    ".products-filter__layout-wrapper input"
  );
  if (productsViewChange.length) {
    productsViewChange.forEach((radio) => {
      radio.addEventListener("change", () => {
        productViewActive = Boolean(parseInt(radio.value));
        filterList();
      });
    });
  }

  const layoutChange = document.querySelectorAll(
    ".products-filter__layouts input"
  );
  if (layoutChange.length) {
    layoutChange.forEach((radio) => {
      radio.addEventListener("change", () => {
        layoutView = radio.value;
        changeLayout();
        updateCookie();
      });
    });
  }

  const state = getCookie("webshopState");
  if (state) {
    setInitialState(state);
  } else {
    clearList();
    showUngroupedProducts();
  }
}

function setInitialState(state) {
  const stateObj = JSON.parse(state);
  primaryGroupUid = stateObj.primaryGroupUid;
  secondaryGroupUid = stateObj.secondaryGroupUid;
  productViewActive = stateObj.productViewActive;
  layoutView = stateObj.layoutView;
  if (primaryGroupUid) {
    primaryCategorySelector.value = primaryGroupUid;
  }
  if (secondaryGroupUid) {
    secondaryCategorySelector.value = secondaryGroupUid;
  }
  if (productViewActive) {
    document.querySelector(
      '.products-filter__layout-wrapper input[value="1"]'
    ).checked = true;
  } else {
    document.querySelector(
      '.products-filter__layout-wrapper input[value="0"]'
    ).checked = true;
  }
  if (layoutView) {
    document.querySelector(
      'input[name="layout"][value="' + layoutView + '"]'
    ).checked = true;
  }
  changeLayout();
  filterList();
}

function changeLayout() {
  if (layoutView == "list") {
    wrapper.classList.remove("products-list__grid-layout");
    wrapper.classList.add("products-list__list-layout");
  }
  if (layoutView == "grid") {
    wrapper.classList.remove("products-list__list-layout");
    wrapper.classList.add("products-list__grid-layout");
  }
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function updateCookie() {
  const state = {
    primaryGroupUid,
    secondaryGroupUid,
    productViewActive,
    layoutView,
  };
  setCookie("webshopState", JSON.stringify(state), 30);
}

function updateCount() {
  const productCountEl = document.querySelector(
    ".products-filter__label--product span"
  );
  const partCountEl = document.querySelector(
    ".products-filter__label--part span"
  );
  productCountEl.textContent = `(${productsCount})`;
  partCountEl.textContent = `(${partsCount})`;
}

function showSubGroupSelector() {
  const selector = document.querySelector(".select-wrapper--productsubgroup");
  selector.classList.remove("hidden");
}

function hideSubGroupSelector() {
  const selector = document.querySelector(".select-wrapper--productsubgroup");
  selector.classList.add("hidden");
}

function clearList() {
  wrapper.innerHTML = "";
  productsCount = 0;
  partsCount = 0;
}

function filterList() {
  primaryGroupUid = parseInt(primaryCategorySelector.value);
  secondaryGroupUid = parseInt(secondaryCategorySelector.value);
  updateCookie();
  clearList();
  if (primaryGroupUid == -1) {
    // hideSubGroupSelector();
    wrapper.classList.remove("products-list__grouped");
    if (productViewActive) {
      showUngroupedProducts();
      tooltipps.init();
      addToCart();
      return;
    }
    showUngroupedParts();
    tooltipps.init();
    addToCart();
    return;
  }
  // showSubGroupSelector();
  wrapper.classList.add("products-list__grouped");
  if (productViewActive) {
    showGroupedProducts();
    tooltipps.init();
    addToCart();
    return;
  }
  showGroupedParts();
  tooltipps.init();
  addToCart();
}

function showUngroupedProducts() {
  const groupItems = Object.values(productSubGroups);
  const ungroupedProducts = [];
  groupItems.forEach((groupedProducts) => {
    groupedProducts.forEach((product) => {
      ungroupedProducts.push(product);
    });
  });
  ungroupedProducts.sort((a, b) => a.title.localeCompare(b.title));
  ungroupedProducts.forEach((product) => {
    const productMarkup = renderProduct(product);
    if (!productMarkup) return;
    wrapper.appendChild(productMarkup);
  });
  countProductsAndParts(ungroupedProducts);
}

function showUngroupedParts() {
  const groupItems = Object.values(productSubGroups);
  const ungroupedProducts = [];
  groupItems.forEach((groupedProducts) => {
    groupedProducts.forEach((product) => {
      ungroupedProducts.push(product);
    });
  });
  const ungroupedParts = [];
  ungroupedProducts.forEach((product) => {
    const parts = product.parts;
    parts.forEach((part) => {
      part.product = product;
      ungroupedParts.push(part);
    });
  });
  ungroupedParts.sort((a, b) =>
    a.itemDescription.localeCompare(b.itemDescription)
  );
  ungroupedParts.forEach((part) => {
    const partMarkup = renderPart(part);
    if (partMarkup) {
      wrapper.appendChild(partMarkup);
    }
  });
  countProductsAndParts(ungroupedProducts);
}

function showGroupedProducts() {
  const filteredProductGroups = [];
  Object.keys(productSubGroups).forEach((groupUid) => {
    filteredProductGroups[groupUid] = [];
  });
  const groupEntries = Object.entries(productSubGroups);
  groupEntries.forEach(([groupUid, groupedProducts]) => {
    groupedProducts.forEach((product) => {
      const primaryGroups = product.productgroup;
      primaryGroups.forEach((primaryGroup) => {
        if (primaryGroup.uid === primaryGroupUid) {
          if (secondaryGroupUid === -1) {
            filteredProductGroups[groupUid].push(product);
          } else {
            const secondaryGroups = product.productsubgroup;
            secondaryGroups.forEach((secondaryGroup) => {
              if (secondaryGroup.uid === secondaryGroupUid) {
                filteredProductGroups[groupUid].push(product);
              }
            });
          }
        }
      });
    });
  });
  Object.keys(filteredProductGroups).forEach((groupUid) => {
    if (filteredProductGroups[groupUid].length === 0) {
      delete filteredProductGroups[groupUid];
    }
  });
  renderProductGroups(filteredProductGroups);
  countProductsAndParts(filteredProductGroups);
}

function showGroupedParts() {
  const filteredProductGroups = [];
  Object.keys(productSubGroups).forEach((groupUid) => {
    filteredProductGroups[groupUid] = [];
  });
  const groupEntries = Object.entries(productSubGroups);
  groupEntries.forEach(([groupUid, groupedProducts]) => {
    groupedProducts.forEach((product) => {
      const primaryGroups = product.productgroup;
      primaryGroups.forEach((primaryGroup) => {
        if (primaryGroup.uid === primaryGroupUid) {
          if (secondaryGroupUid === -1) {
            filteredProductGroups[groupUid].push(product);
          } else {
            const secondaryGroups = product.productsubgroup;
            secondaryGroups.forEach((secondaryGroup) => {
              if (secondaryGroup.uid === secondaryGroupUid) {
                filteredProductGroups[groupUid].push(product);
              }
            });
          }
        }
      });
    });
  });
  Object.keys(filteredProductGroups).forEach((groupUid) => {
    if (filteredProductGroups[groupUid].length === 0) {
      delete filteredProductGroups[groupUid];
    }
  });
  renderPartGroups(filteredProductGroups);
  countProductsAndParts(filteredProductGroups);
}

function renderProductGroups(filteredProductGroups) {
  const template = templates.container;
  filteredProductGroups = sortGroupsBySorting(filteredProductGroups);
  filteredProductGroups.forEach((groupProducts) => {
    const groupClone = template.content.cloneNode(true);
    const hasGroups = groupProducts[0].productsubgroup[0];
    const headline = groupClone.querySelector(".products__container-header");
    if (hasGroups) {
      const groupTitle = groupProducts[0].productsubgroup[0].title;
      headline.textContent = groupTitle;
    }
    if (!hasGroups) {
      headline.remove();
    }
    const content = groupClone.querySelector(".products__container-content");
    groupProducts = sortGroupProductsAlphabetically(groupProducts);
    groupProducts.forEach((product) => {
      const productClone = renderProduct(product);
      if (productClone) {
        content.appendChild(productClone);
      }
    });
    if (content.children.length > 0) {
      wrapper.appendChild(groupClone);
    }
  });
}

function sortGroupProductsAlphabetically(groupProducts) {
  return groupProducts.sort((a, b) => a.title.localeCompare(b.title));
}

function sortGroupsBySorting(filteredProductGroups) {
  return filteredProductGroups.sort((a, b) => {
    const aSorting = a[0].productsubgroup[0].sorting;
    const bSorting = b[0].productsubgroup[0].sorting;
    return aSorting - bSorting;
  });
}

function renderPartGroups(filteredProductGroups) {
  const template = templates.container;
  filteredProductGroups.forEach((groupProducts) => {
    const groupClone = template.content.cloneNode(true);
    const hasGroups = groupProducts[0].productsubgroup[0];
    const headline = groupClone.querySelector(".products__container-header");
    if (hasGroups) {
      const groupTitle = groupProducts[0].productsubgroup[0].title;
      headline.textContent = groupTitle;
    }
    if (!hasGroups) {
      headline.remove();
    }
    const content = groupClone.querySelector(".products__container-content");
    groupProducts = sortGroupProductsAlphabetically(groupProducts);
    groupProducts.forEach((product) => {
      const parts = product.parts;
      parts.forEach((part) => {
        part.product = product;
        const partClone = renderPart(part);
        if (partClone) {
          content.appendChild(partClone);
        }
      });
    });
    if (content.children.length > 0) {
      wrapper.appendChild(groupClone);
    }
  });
}

function renderProduct(product) {
  if (!product || product.hidden) return;
  if (!product.productgroup[0]) {
    return;
  }
  const template = templates.product;
  const productClone = template.content.cloneNode(true);
  let productTitle = productClone.querySelector(
    ".products-list__productname a"
  );
  if (productTitle) {
    productTitle.href = product.detailPageLink;
  } else {
    productTitle.remove();
    productTitle = productClone.querySelector(".products-list__productname");
  }
  const badgeContainer = productClone.querySelector(
    ".products-list__item-badge-wrapper"
  );
  if (product.productgroup.length > 0) {
    const firstBadge = templates.firstBadge.content.cloneNode(true);
    const badgeTitle = firstBadge.querySelector(".cart__product-group-title");
    const badgeTooltip = firstBadge.querySelector(".tooltip");
    badgeTitle.textContent = product.productgroup[0].title;
    badgeTooltip.textContent = product.productgroup[0].title;
    badgeContainer.appendChild(firstBadge);
    if (product.productgroup.length > 1) {
      const additionalBadge = templates.AdditionalBadge.content.cloneNode(true);
      const additionalBadgeTitle = additionalBadge.querySelector(
        ".cart__product-group-title"
      );
      const additionalBadgeTooltip = additionalBadge.querySelector(".tooltip");
      additionalBadgeTitle.textContent = "...";
      let badgeText = "";
      product.productgroup.forEach((productgroup, index) => {
        if (index === 0) return;
        badgeText += productgroup.title;
        if (index < product.productgroup.length - 1) {
          badgeText += ", ";
        }
      });
      additionalBadgeTooltip.textContent = badgeText;
      badgeContainer.appendChild(additionalBadge);
    }
  }
  productTitle.textContent = product.title;
  const articleNumber = productClone.querySelector(
    ".products-list__articlenumber"
  );
  articleNumber.textContent = product.articleNumber;
  const detailLink = productClone.querySelector(
    ".products-list__item-right .products-list__detail-link"
  );
  if (detailLink) {
    detailLink.href = product.detailPageLink;
  }
  const button = productClone.querySelector(".products-list__cart-button");
  button.dataset.uid = product.uid;
  button.dataset.product = 1;
  return productClone;
}

function renderPart(part) {
  if (!part) return;
  const product = part.product;
  const template = templates.product;
  const partClone = template.content.cloneNode(true);
  let productTitle = partClone.querySelector(".products-list__productname a");
  if (productTitle && !product.hidden && product.productgroup[0]) {
    productTitle.href = product.detailPageLink;
  } else {
    productTitle.remove();
    productTitle = partClone.querySelector(".products-list__productname");
  }
  const badgeContainer = partClone.querySelector(
    ".products-list__item-badge-wrapper"
  );
  const firstBadge = templates.firstBadge.content.cloneNode(true);
  const badgeTitle = firstBadge.querySelector(".cart__product-group-title");
  const badgeTooltip = firstBadge.querySelector(".tooltip");
  badgeTitle.textContent = product.title;
  badgeTooltip.textContent = product.title;
  if ((product.hidden || !product.productgroup[0]) && firstBadge) {
    const badgeEl = firstBadge.querySelector(".products-list__item-badge");
    badgeEl.classList.remove("products-list__item-badge--white");
    badgeEl.classList.add("products-list__item-badge--grey");
  }
  badgeContainer.appendChild(firstBadge);
  productTitle.textContent = part.itemDescription;
  const articleNumber = partClone.querySelector(
    ".products-list__articlenumber"
  );
  articleNumber.textContent = part.partNumber;
  if (part.product) {
    const detailLink = partClone.querySelector(
      ".products-list__item-right .products-list__detail-link"
    );
    if (detailLink && !product.hidden && product.productgroup[0]) {
      detailLink.href = product.detailPageLink;
    } else {
      detailLink.remove();
    }
  }
  const button = partClone.querySelector(".products-list__cart-button");
  button.dataset.uid = part.uid;
  button.dataset.product = 0;
  return partClone;
}

function countProductsAndParts(products, parts) {
  let productsArray = [];
  if (products[0] && products[0].title) {
    productsArray = products;
  }
  if (!productsArray.length && products.length) {
    products.forEach((groupProducts) => {
      productsArray = productsArray.concat(groupProducts);
    });
  }
  productsCount = 0;
  productsArray.forEach((product) => {
    if (!product.hidden && product.productgroup[0]) {
      productsCount++;
    }
  });
  if (!parts) {
    let partsNum = 0;
    productsArray.forEach((product) => {
      const parts = product.parts || product[0].parts;
      partsNum += parts.length;
    });
    partsCount = partsNum;
    updateCount();
    return;
  }
  partsCount = parts.length;
  updateCount();
}

export default initializeProductList;
